<template>
  <div class="vertical-scroll-buttons">
    <button
        :disabled="pagination.currentPage === 1"
        class="vertical-scroll-btn-first"
        type="button"
        @click="setPage(1)"
    >
      <i class="fas fa-angle-double-left"></i>
    </button>
    <button
        :disabled="pagination.currentPage === 1"
        class="vertical-scroll-btn-second"
        @click="setPage(pagination.currentPage - 1)"
    >
                            <span>
                              <i class="fas fa-angle-left"></i>
                            </span>
      <!--                          <span>-->
      <!--                            {{ pagination.from }}-->
      <!--                          </span>-->
    </button>
    <button
        class="vertical-scroll-btn-menu"
        data-toggle="dropdown"
        aria-expanded="false"
        @click="paginationDropDownUp = true"
        v-if="pagination.total !== 0 || true"
    >
                            <span class="pagination-info-span"
                            >{{ pagination.from }}/{{ pagination.to }} of
                              {{ pagination.total }}</span
                            >
      <span
          v-if="
                                pagination.lastPage === 1 &&
                                  pagination.total < 8
                              "
      ><i class="fas fa-bars"></i
      ></span>
    </button>
    <div
        class="dropdown-menu p-xy-8 pagination-vertical-dropdown"
        :class="{
                              'pagination-vertical-dropdown-down': !paginationDropDownUp
                            }"
    >
      <div class="listview-pagenum m-xy-0 p-x-8 m-b-4">
                              <span>Page {{ pagination.currentPage }}</span
                              >&nbsp; &nbsp; <span>of</span>&nbsp;
        <strong
        ><span id="totalPageCount">{{
            pagination.lastPage
          }}</span></strong
        >
      </div>
      <div class="listViewPagingBox">
        <input
            v-model="pageNumInput"
            type="search"
            placeholder="Jump To"
            class="listViewPagingInput p-xy-0"
        />&nbsp;
        <button
            type="button"
            id="listViewPagingInputSubmit"
            @click="setPage(pageNumInput)"
            :disabled="pageNumInput > pagination.lastPage"
        >
          GO
        </button>
      </div>
    </div>
    <button
        :disabled="
                              pagination.currentPage === pagination.lastPage
                            "
        class="vertical-scroll-btn-third"
        @click="setPage(pagination.currentPage + 1)"
    >
      <!--                          <span>-->
      <!--                            {{ pagination.to }}-->
      <!--                          </span>-->

      <span>
                              <i class="fas fa-angle-right"></i>
                            </span>
    </button>
    <button
        class="vertical-scroll-btn-fourth"
        :disabled="
                              pagination.currentPage === pagination.lastPage &&
                                pagination.total
                            "
        @click="setPage(pagination.lastPage)"
    >
      <i class="fas fa-angle-double-right"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "Pagination.component",
  data(){
    return{
      pagination: {
        currentPage: 1,
        perPage: 5,
        from: 1,
        to: 1,
        lastPage: 1,
        total: 0
      },
    }
  },
  methods:{
    setPage(pageNum) {
      this.pagination.currentPage = pageNum;
      // this.fetchClients(true);
      this.pageNumInput = "";
    },
  }
}
</script>

<style scoped>
div.vertical-scroll-buttons button:disabled {
  cursor: context-menu !important;
}
div.vertical-scroll-buttons button {
  margin-right: 2px;
}
.vertical-scroll-buttons {
  transition: all 0.3s ease-in-out;
  color: #988d23;
  display: flex;
  position: relative;
  height: 100%;
}
.vertical-scroll-btn-first,
.vertical-scroll-btn-fourth {
  flex: 1;
  outline: none;
  border: none;
  margin-right: 2px;
}
.vertical-scroll-btn-second,
.vertical-scroll-btn-third {
  flex: 4;
  width: 20px;
  /*width: 52px;*/
  /*border-bottom: none;*/
  /*border-top: none;*/
  border: none;
  outline: none;
  font-size: 11.5px;
}
.vertical-scroll-btn-first {
  border-radius: 10px 0px 0px 10px;
  border-bottom: none;
}
.vertical-scroll-btn-fourth {
  border-radius: 0px 10px 10px 0px;
  border-top: none;
}

.vertical-scroll-buttons button:focus {
  background: #d7d7d7;
  color: white;
}
.vertical-scroll-buttons button {
  background: #7a7a7a;
  color: #ffffff;
}
.vertical-scroll-buttons button span {
  font-weight: 500;
}
.vertical-scroll-buttons button:hover {
  background: #515151;
  color: #ffffff;
}
.vertical-scroll-buttons p {
  /*font-size: 10px;*/
  font-size: 14px;
  font-weight: bold;
}
.vertical-scroll-btn-menu:hover {
  background: #6b6a6a;
  color: #ffffff;
}
.vertical-scroll-btn-menu {
  border-radius: 0px 0px 0px 0px;
  background: #a0a0a0;
  color: #ffffff;
  /*margin-right: 2px;*/
  border: none;
  outline: none;
}
.vertical-scroll-btn-menu {
  padding: 1px;
  border: none;
  outline: none;
  width: 122px;
  /* width: fit-content; */
  font-size: 12px;
  /* margin-left: 3px;*/
  min-width: 122px;
}

.vertical-scroll-buttons button[disabled] {
  /*background-color: inherit;*/
  background: #888888;
  opacity: 0.7;
  cursor: not-allowed;
}
/*.pagination-vertical-dropdown {*/
/*  top: 38px;*/
/*  left: 28px;*/
/*  border-radius: 5px;*/
/*  color: #ffffff;*/
/*}*/
/*.pagination-vertical-dropdown {*/
/*  top: 38px;*/
/*  left: 28px;*/
/*  border-radius: 5px;*/
/*  color: #ffffff;*/
/*}*/
/*.tab-pane-wrapper {*/
/*  display: inline-flex;*/
/*}*/
/*.pagination-vertical-dropdown-down {*/
/*  top: 557px;*/
/*}*/
.listViewPagingInput {
  width: 60px;
  /*width: 70px;*/
  padding: 1px;
  /*margin-top: 5px;*/
  margin-left: 5px;
  font-size: 10pt;
  text-align: center;
  vertical-align: middle;
  height: 24px;
  opacity: 1;
  /*border-radius: 1px;*/
  border-radius: 5px;
  border-style: solid;
  border-color: #808080;
  border-width: thin;
  background-color: #efefef;
  color: gray;
}
#listViewPagingInputSubmit {
  margin-left: 15px;
  margin-top: 5px;
  border-radius: 5px;
  line-height: 11px;
  cursor: pointer;
  font-weight: 500;
  /*padding: 6px 16px !important;*/
  /*color: black !important;*/
  width: 60px;
  border: thin solid #808080 !important;
  opacity: 1;
  font-size: 11px;
  height: 24px;
}
.listview-pagenum {
  text-align: center;
  white-space: nowrap;
  padding: 3px 10px;
  margin-bottom: 6px;
  font-size: 13px;
  color: gray;
}
</style>